import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class ConfigEditorRoute extends Route
{
	@service ajax

	async model()
	{
		const config = await this.ajax.request("classGroupsConfig.json");
		return config;
	}
}
